
import React from "react";
import { Classname } from "@rivtn/noseur";
import { useInView } from "../../hooks";
import { i18nManager } from "../../i18n";
import SectionHeader from "../common/SectionHeader";
import styles from "../../assets/style.module.css";

export interface SponsorsProps {
    sponsors: string[];
}

function Sponsors({ sponsors }: SponsorsProps) {

    const [ref, inView] = useInView();
    const labels = i18nManager.Labels.home;

    if (!sponsors.length) return null;

    return (<section className={Classname.build(styles["section"], styles["sponsors"])}>
        <div ref={ref} className={Classname.build(styles["container"], styles["reveal"], { [styles["in-view"]]: inView })}>
            <SectionHeader eyebrow={labels.sponsors_eyebrow} title={labels.sponsors_title} titleEm={labels.sponsors_title_em} subtitle={labels.sponsors_desc} />
            <div className={styles["sponsor-row"]}>
                {sponsors.map((s) => (<div key={s} className={styles["sponsor"]}>
                    <img alt={s} src={s} loading="lazy" />
                </div>))}
            </div>
        </div>
    </section>);
}

export default Sponsors;
